import Topbar from "components/Topbar/Topbar";

import localize from "lang/localize";

class CustomTopbar extends Topbar {
  /* Custom: render nothing for "topic" */
  renderTopbarTitle() {
    switch (this.props.state) {
      case "home-single":
      case "projecthome":
        return this.props.project ? this.props.project.title : "";
      case "topic":
        return "";
      case "challenge":
        if (!!this.props.challenge && !!this.props.challenge.title) {
          return this.props.challenge.title;
        } else if (
          !!this.props.challenge &&
          this.props.challenge.error.indexOf("locked") !== -1
        ) {
          return (
            localize("button_quest_locked", this.props.language)
              .charAt(0)
              .toUpperCase() +
            localize("button_quest_locked", this.props.language).substring(1)
          );
        } else {
          return "";
        }
      case "challenge-comments":
        if (!!this.props.challenge && !!this.props.challenge.title) {
          return (
            localize("comments_novariable_text", this.props.language) +
            ": " +
            this.props.challenge.title
          );
        } else if (
          !!this.props.challenge &&
          this.props.challenge.error.indexOf("locked") !== -1
        ) {
          return (
            localize("button_quest_locked", this.props.language)
              .charAt(0)
              .toUpperCase() +
            localize("button_quest_locked", this.props.language).substring(1)
          );
        } else {
          return "";
        }
      case "topic-category":
        return this.props.topicCategory ? this.props.topicCategory.title : "";
      case "challenge-category":
        return this.props.challengeCategory
          ? this.props.challengeCategory.title
          : "";
      default:
        return this.props.title ? this.props.title : "";
    }
  }
}

export default CustomTopbar;
